import { Box, HStack, Text, VStack } from '@chakra-ui/layout';
import { ResourceStatusBadge } from '@duke-hq/ui/components/ResourceStatusBadge/ResourceStatusBadge';
import { Trans } from '@lingui/react/macro';
import { RouterOutputs } from '@duke-hq/svc-api/admin';

export function AssessmentMetadata({
  assessmentSubmission,
}: {
  assessmentSubmission: RouterOutputs['assessments']['getById'];
}) {
  return (
    <Box bg="bg.emphasis" py={'2'} px={'6'}>
      <HStack justify="space-between">
        <VStack align="flex-start" spacing={'0'}>
          <Text fontSize="sm" fontWeight="bold" color="gray.800">
            {assessmentSubmission?.unitAssessment?.unitOfCompetency.title}
          </Text>
          <Text fontSize="sm" color="gray.800">
            {assessmentSubmission?.unitAssessment?.unitOfCompetency.code ?? `Resource identifier`}
          </Text>
        </VStack>
        <HStack>
          <Text fontSize="sm" color="gray.800">
            <Trans>Status</Trans>:
          </Text>
          <ResourceStatusBadge status={assessmentSubmission.outcome} />
        </HStack>
      </HStack>
    </Box>
  );
}
